<template>
  <div class="tab-journals">
    <n-loader :loading="$var('loading')" />
    
    <div class="items">
      <n-link :to="{ name: 'journals.index', params: { projectId: project.id, journal: 'main', }, }">Журнал производства работ</n-link>
      <n-link :to="getRoute('input')">Журнал верификации закупленной продукции</n-link>
      <n-link :to="getRoute('author')">Журнал авторского надзора</n-link>
      <n-link :to="getRoute('tech')">Журнал технического надзора</n-link>
    </div>
    <n-form-item title="Специальные журналы">
      <div class="items">
        <n-button v-if="canJournals" @click="$var('addJournal', true)">Выдать журнал</n-button>
        <div v-for="journal in specs" :key="journal.name">
          <n-link style="display: inline-block; margin-right: 20px" :to="getRoute(journal.name)">{{ journal.title }}</n-link>
          <n-button v-if="canJournals" style="font-size: .7em" icon="trash" @click="removeJournal(journal.id)" />
        </div>
      </div>
    </n-form-item>

    <n-modal v-if="$var('addJournal')" :loading="$var('loadingJournals')" @close="$var('addJournal', false)">
      <n-form @submit="addJournal">
        <n-items>
          <n-select title="Журнал" :data="newJournals" v-bind="$form.input('journal', 'select')" />
          <n-button wide color="primary" type="submit">Выдать журнал</n-button>
        </n-items>
      </n-form>
    </n-modal>
  </div>
</template>

<script>
export default {
  name: 'TabJournals',
  props: [ 'project', ],
  data: () => ({
    columns: [
      { name: 'title', title: 'Наименование акта', },
      { name: 'status', title: 'Статус', },
      { name: 'createdAt', title: 'Дата создания', },
      { name: 'tools', title: '', },
    ],
    specs: [],
    newJournals: [],
    statuses: {
      draft: 'Черновик',
      waiting: 'Ожидает подписания',
      approved: 'Подписан',
      rejected: 'Отклонен',
    },
  }),
  computed: {
    canJournals() {
      return $app.auth.can('projects_edit_journals', this.project.id)
    },
  },
  created() {
    this.load()
    this.loadJournals()
    this.$form.init({
      journal: null,
    })
  },
  methods: {
    getRoute(name) {
      return { name: 'journals.index', params: { projectId: this.project.id, journal: name, }, }
    },
    load() {
      this.$var('loading', true)
      $api.journals.get(this.project.id).filter({ tag: 'spec', }).then((response) => {
        this.specs = response.data.content
      }).finally(() => {
        this.$var('loading', false)
      })
    },
    loadJournals() {
      this.$var('loadingJournals', true)
      $api.journalsOld.getAll(this.project.id).filter({ tag: 'spec', }).then((response) => {
        this.newJournals = response.data.content
      }).finally(() => {
        this.$var('loadingJournals', false)
      })
    },
    addJournal() {
      this.$var('loadingJournals', true)
      $api.journals.add(this.project.id, this.$form.get('journal').name).then((response) => {
        this.load()
        this.$var('addJournal', false)
        this.$form.init({
          journal: null,
        })
      }).finally(() => {
        this.$var('loadingJournals', false)
      })
    },
    removeJournal(id) {
      this.$var('loading', true)
      $api.journals.remove(this.project.id, id).then((response) => {
        this.load()
      }).catch(() => {
        this.$var('loading', false)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .tab-journals {
    .tools {
      margin-bottom: 20px;
    }
    
    .items {
      margin-bottom: 20px;
      &>* {
        display: block;
      }
    }
  }
</style>
